<template>
<div>
  <el-table
    :data="dataList"
    v-loading="dataListLoading"
    border
    style="width: 100%"
    :max-height="maxTableHeight ? maxTableHeight : '100%'"
  >
    <el-table-column
      type="index"
      header-align="center"
      align="center"
      width="50"
      label="行号"
    ></el-table-column>
    <el-table-column label="系统编号"  prop="product.sysCode" width="80" header-align="center" align="center" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column label="品番号"  prop="code" header-align="center" align="center" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column label="SKU"  prop="skuCode" header-align="center" align="center" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column label="品名"  align="center" prop="name" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column label="中文名"  align="center" prop="nameZh" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column
        label="颜色"
        prop="color"
        header-align="center"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
    >
    </el-table-column>
    <el-table-column
        label="规格"
        prop="size"
        header-align="center"
        align="center"
        width="100"
        :show-overflow-tooltip="true"
    >
    </el-table-column>
    <el-table-column
        label="返单号"
        prop="backCount"
        header-align="center"
        align="center"
        width="80"
        :show-overflow-tooltip="true"
    >
    </el-table-column>
    <el-table-column
        prop="count"
        label="计划数"
        header-align="center"
        align="center"
        width="100"
    >
    </el-table-column>
    <el-table-column
        prop="purchaseMaterialCount"
        label="采购种数"
        header-align="center"
        align="center"
        width="100"
    >
      <template #default="{row}">
        <div style="color:red;" v-if="row.purchaseMaterialCount<row.bomList.length">{{row.purchaseMaterialCount}}</div>
        <div v-else>{{row.purchaseMaterialCount}}</div>
      </template>
    </el-table-column>

    <el-table-column
        prop="checkInCount"
        label="已生产"
        header-align="center"
        align="center"
        width="100"
    >
    </el-table-column>
    <el-table-column
        prop="checkOutCount"
        label="已发货"
        header-align="center"
        align="center"
        width="100"
    >
    </el-table-column>
    <el-table-column
        label="未发货"
        header-align="center"
        align="center"
        width="100"
    >
      <template v-slot="scope">
        {{scope.row.checkInCount-scope.row.checkOutCount}}
      </template>
    </el-table-column>
    <el-table-column
        label="欠发货"
        header-align="center"
        align="center"
        width="100"
    >
      <template v-slot="scope">
        {{scope.row.count-scope.row.checkOutCount}}
      </template>
    </el-table-column>
    <el-table-column label="外销单价" header-align="center" align="center"  v-if="exColumns.indexOf('price')===-1" width="100">
      <template slot-scope="scope">
        {{ scope.row.amount }}
      </template>
    </el-table-column>
    <el-table-column
        :label="$t('handle')"
        header-align="center"
        align="center"
        width="100"
        v-if="hasOpt"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="showBomSaveDialog(scope.row)"
            >单耗设置{{(scope.row.bomCount>0)?`【${scope.row.bomCount}】`:``}}</el-button
          >
        </template>
      </el-table-column>
  </el-table>
  <BomSaveDialog ref="bomSaveDialog" @change="bomChange"></BomSaveDialog>
  </div>
</template>

<script>
import BomService from '@/service/BomService'
import BomSaveDialog from '@/views/modules/trade/bom/save';
import mixinViewModule from "@/mixins/view-module";
export default {
  name: "order-detail",
  mixins: [mixinViewModule],
  components: {BomSaveDialog},
  props: {
    hasOpt: {
      type: Boolean,
      default: false,
    },
    agreementId: {
      type: String,
      default: "",
    },
    maxTableHeight: {
      type: Number,
      default: null,
    },
    exColumns:{
      type:Array,
      default:()=>{
        return []
      }
    },
    columns:{
      type:Array,
      default:()=>{
        return []
      }
    },
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/agreement/detail/list",
        getDataListIsPage: false,
        activatedIsNeed: false,
      },
      dataForm: {
        agreementId: "",
      },
    };
  },
  watch: {
    agreementId: {
      handler: function(newVal) {
        this.dataList = [];
        if (newVal && newVal !== "") {
          this.dataForm.agreementId = newVal;
          this.reload()
        }
      },
      immediate: true,
    },
  },
  methods: {
    beforeTableBinding(dataList){
      dataList.forEach(item=>{
        if(item.bomList){
          item.bomCount=item.bomList.length
        }else{
          item.bomList=[]
          item.bomCount=0
        }

        if(item.otherCost){
          item.otherCost=JSON.parse(item.otherCost)
        }
      })
    },
    showBomSaveDialog(row) {
      this.$refs.bomSaveDialog.parentId = row.id;
      this.$refs.bomSaveDialog.init();
    },
    bomChange(bomList) {
      BomService.doSave(bomList).then(res=>{
        this.getDataList()
        this.$message.success("保存成功");
      })
    },
  },
};
</script>
